/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Offline_Dialog_TitleInputs */



/**
* | output |
* | --- |
* | "Record this conversation" |
*
* @param {Meeting_Offline_Dialog_TitleInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_offline_dialog_title = /** @type {((inputs?: Meeting_Offline_Dialog_TitleInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Offline_Dialog_TitleInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Gesprek opnemen")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Enregistrer la conversation")
	return /** @type {LocalizedString} */ ("Record this conversation")
});